<template>
    <div id="page" class="page">
        

        <interne_menu></interne_menu>
               
        <!-- Mentions legales -->
        <section id="faqs-1" class="bg-fixed bg-lightgrey wide-60 faqs-section division contact-bck">						
            <div class="container">


                <!-- SECTION TITLE -->	
                <div class="row">	
                    <div class="col-md-10 offset-md-1 section-title">	

                        <!-- Title 	-->	
                        <h2 class="h2-lg">Questions Générales</h2>	

                        
                    </div> 	 <!-- End row --> 	
                </div>	 <!-- END SECTION TITLE -->	

                <div class="row">
                    
                    <!-- QUESTIONS HOLDER -->
                    <div class="col-lg-6">
                        <div class="questions-holder ind-30">


                            <!-- QUESTION #1 -->
                            <div class="question animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="300">

                                <!-- Question -->
                                <h5 class="h5-sm">Qu’est ce qu’APAYM ?</h5>

                                <!-- Answer -->
                                <p>APAYM est une application mobile qui vous permets de gérer toutes vos opérations financières sur la carte abidjan.net mais aussi sur d’autres cartes.
                                     Vous bénéficiez également de services liés afin de rendre la vie plus pratique. APAYM c’est :</p>

                                     <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                             <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                             <p>simple et instantané. Téléchargez l’application et inscrivez-vous en 40 secondes.</p>							
                                    </div>
                                    
                                    <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                             <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                             <p>100% sécurisé : vos données bancaires sont cryptées et restent confidentielles</p>						
                                    </div>

                            </div>	

                            <!-- QUESTION #2 -->
                            <div class="question animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="500">

                                <!-- Question -->
                                <h5 class="h5-sm">Comment enregistrer mes cartes bancaires ?</h5>

                                <!-- Answer -->
                                <p>Rien de plus simple. Pour ajouter votre carte bancaire, vous pouvez soit la scanner en utilisant l'appareil photo du téléphone, soit inscrire les chiffres de votre carte manuellement.</p>
                                
                            </div>


                            

                        </div>
                    </div>	<!-- END  QUESTIONS HOLDER -->

                    <!-- QUESTIONS HOLDER -->
                    <div class="col-lg-6">
                        <div class="questions-holder ind-30">


                            <!-- QUESTION #3 -->
                            <div class="question animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="600">

<!-- Question -->
<h5 class="h5-sm">Est ce que je peux rajouter une carte bancaire étrangère ?</h5>

<!-- Answer -->
<p>Toutes les cartes Visa sont acceptées</p>




</div>

<!-- QUESTION #4 -->
<div class="question animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="600">

<!-- Question -->
<h5 class="h5-sm">Peut-on faire des virements depuis une carte Abidjan.net vers des comptes bancaires et des comptes mobile money?</h5>

<!-- Answer -->
<p>Oui, c’est tout à fait possible. Vous pouvez aussi recharger votre carte par virement bancaire et compte mobile money</p>

</div>

<!-- QUESTION #4 -->
<div class="question animated fadeInUp visible" data-animation="fadeInUp" data-animation-delay="600">

<!-- Question -->
<h5 class="h5-sm">Qu'est ce que le lien de paiement APAYM Pro ?</h5>

<!-- Answer -->
<p>Le lien de paiement est un lien URL sécurisé à usage unique dont dispose un marchand APAYM PRO. Il peut encaisser instantanément ses clients à distance et partout dans le monde entier.</p>

</div>



                        </div>
                    </div>	<!-- END QUESTIONS HOLDER -->

                    <div class="col-lg-10 offset-lg-1">
                        <div class="press-txt text-center m-top-20">	

                            <!-- Text -->
                            <p></p>
                            <p class="p-md">Nos équipes commerciales et techniques sont à votre écoute pour<br> répondre rapidement à tous vos besoins.
                            </p>

                            <!-- Button -->						
                            <RouterLink to="nous-contacter" class="btn btn-lightorange ">Contacter le service client</RouterLink>

                        </div>
						</div>

                </div>	<!-- End row -->		



            </div>	   <!-- End container -->		
			</section>
        <!-- Mentions legales -->

       

        <footer_menu></footer_menu>
    </div>

</template>

<script>
import interne_menu  from '../components/interne_menu.vue';
import footer_menu  from '../components/footer_menu.vue';


//import { useMeta } from 'vue-meta'



export default {
  name: 'nos_cartes',

  components:{
      'interne_menu' :interne_menu,
      'footer_menu' :footer_menu
    } ,

    head() {
    return {
      meta: [
        {
          name: 'description',
          content: 'Contactez-nous pour plus d\'informations '
        },
        {
          name: 'keywords',
          content: 'contact, information, email, téléphone'
        }
        // ... autres balises meta ...
      ]
    }
  },

  data() {
    return {
      myData: null
    }
  },
  beforeRouteUpdate(to, from, next) {
    // Récupérer les données du composant avant qu'il ne soit mis à jour
    this.myData = to.params.id
    next()
  }    
  
}

</script>

<style scoped>

.wide-60 {
    padding-top: 190px;
    padding-bottom: 60px;
}
.btn-lightorange {
    color: #fff;
    background-color: #ff9e00;
    border-color: #f3a72e;
}

.orange{
color: #ff9e00;
}
.h5-sm{
    color: #261b64;
}

</style>

